/** Možnost určit, že se komponenta vztahuje k masterObjectu a spouští se nad ním */
export interface IUseMasterObject {
    /** Příznak, že se komponenta vztahuje k masterObjectu a spouští se nad ním */
    useMasterObject: boolean;
}

export class IUseMasterObject {
    private static _properties: (keyof IUseMasterObject)[] = ["useMasterObject"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && IUseMasterObject._properties.every((property) => Reflect.has(instance, property));
    }
}
